import { render, staticRenderFns } from "./EventsList.vue?vue&type=template&id=6d08525c&scoped=true&"
import script from "./EventsList.vue?vue&type=script&lang=js&"
export * from "./EventsList.vue?vue&type=script&lang=js&"
import style0 from "./EventsList.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./EventsList.vue?vue&type=style&index=1&id=6d08525c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d08525c",
  null
  
)

export default component.exports